import { render } from "./LotNotes.vue?vue&type=template&id=a19ce88c&scoped=true&ts=true&lang=pug"
import script from "./LotNotes.vue?vue&type=script&lang=ts&setup=true"
export * from "./LotNotes.vue?vue&type=script&lang=ts&setup=true"

import "./LotNotes.vue?vue&type=style&index=0&id=a19ce88c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19ce88c"]])

export default __exports__